/** Parses a date-only API value without applying a UTC offset. */
export function parseCalendarDate(s: string): Date {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function localizeDate(date: Date, opts: Intl.DateTimeFormatOptions, lang: string): string {
  const locale = (lang || 'en') === 'fr' ? 'fr-CA' : 'en-CA';
  return new Intl.DateTimeFormat(locale, opts).format(date);
}

export function localizeCalendarDate(s: string, opts: Intl.DateTimeFormatOptions, lang: string): string {
  return localizeDate(parseCalendarDate(s), opts, lang);
}
